import { render, staticRenderFns } from "./loopDetails.vue?vue&type=template&id=13f960f1&scoped=true"
import script from "./loopDetails.vue?vue&type=script&lang=js"
export * from "./loopDetails.vue?vue&type=script&lang=js"
import style0 from "./loopDetails.vue?vue&type=style&index=0&id=13f960f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f960f1",
  null
  
)

export default component.exports